<ng-content></ng-content>
@if (activeStep(); as active) {
  <nr-guided-tour-layer
    [target]="active.target"
    [step]="active.step"
    [stepNumber]="active.stepNumber"
    [stepCount]="active.stepCount"
    (next)="next()"
    (skip)="skip()"
    (done)="finish()"
  ></nr-guided-tour-layer>
}
